module.exports = __webpack_public_path__ + "img/Group 1030.403af09c.png";